import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import React from 'react'
import { useIntl } from 'react-intl'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
}

function LandingPageLoyaltyAirportTransferBenefitsModal(props: Props) {
  const { image } = props
  const intl = useIntl()

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'DMAv70kqkC',
        defaultMessage: 'Free airport chauffeur service',
        description: 'Title for the airport chauffeur transfer benefit details modal',
      })}
      />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="airport_transfer" />
            <BodyText variant="large">
              {intl.formatMessage({
                id: 'mw/4NBdeEE',
                defaultMessage: 'Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.',
                description: 'Description of the airport chauffeur transfer benefit in the details modal',
              })}
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">{intl.formatMessage({
                id: '+Z5NgsPpxp',
                defaultMessage: 'How it works',
                description: 'Section heading explaining how the airport transfer benefit works',
              })}
              </Heading>
              <BodyText variant="large">
                {intl.formatMessage({
                  id: 'uxEv1XvQEN',
                  defaultMessage: 'When booking select overseas hotels, you\u2019ll have the option to add a private transfer during checkout. Once selected, your transfer will automatically be added to your booking at no additional cost.',
                  description: 'Explanation of how to add a private airport transfer during hotel checkout',
                })}
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyAirportTransferBenefitsModal
